<!-- @format -->

<template>
    <div class="d-flex align-center gap-2">
        <Link :href="route(root.name, root.params)" class="hidden-xs">
            <v-icon icon="mdi-chevron-left" size="x-large" />
        </Link>

        <span v-if="prepend">
            <v-img width="16px" :src="prepend" />
        </span>
        <v-breadcrumbs>
            <v-breadcrumbs-item v-for="(item, index) in items" :key="index">
                <template v-if="!item.disabled">
                    <v-menu v-if="item.description" open-on-hover>
                        <template #activator="{ props }">
                            <Link v-bind="props" :href="item.href" class="pr-2">
                                {{
                                    $t(item.text)
                                }}
                            </Link>
                        </template>
                        <v-card class="pa-6" rounded="lg" min-width="300">
                            <!-- eslint-disable-next-line vue/no-v-html -->
                            <div v-html="$t(item.description)" />
                        </v-card>
                    </v-menu>
                    <Link v-else-if="!item.back" v-bind="props" :href="item.href" class="pr-2">
                        {{
                            $t(item.text)
                        }}
                    </Link>
                    <a v-else href="javascript:window.history.back()">
                    	{{
                            $t(item.text)
                        }}
                    </a>
                    <span>|</span>
                </template>

                <span v-else class="font-weight-bold">{{ $t(item.text) }}</span>
            </v-breadcrumbs-item>
        </v-breadcrumbs>
        <slot />
    </div>
</template>

<script setup>
import { Link } from "@inertiajs/vue3"

// Props
const props = defineProps({
    items: {
        type: Array,
        default() {
            return [
            {
            text: "company.dashboard.cdf",
            href: route('homepage'),
            description: "company.dashboard.cdf",
            disabled: false,
            back: false
        }]
        }
    },
    prepend: {
        type: String,
        default: ""
    },
    // Default link to put on the root element
    root:{
        type: Object,
        default: {
            name: 'homepage',
            params: {}
        }
    }
})
</script>
